// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as DayPickerRange from "./DayPickerRange.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";

function startOfDay(date) {
  let date$1 = new Date(date.getTime());
  date$1.setHours(0, 0, 0, 0);
  return date$1;
}

function endOfDay(date) {
  let date$1 = new Date(date.getTime());
  date$1.setHours(23, 59, 59, 999);
  return date$1;
}

function InputDateRangeField(props) {
  let onChange = props.onChange;
  let __required = props.required;
  let placeholder = props.placeholder;
  let value = props.value;
  let required = __required !== undefined ? __required : false;
  let mounted = React.useRef(false);
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popover = match.state;
  let match$1 = Hover.use(popoverTriggerRef, undefined, undefined);
  let match$2 = React.useState(() => {
    if (value !== undefined) {
      return [
        value[0],
        value[1]
      ];
    } else {
      return [
        undefined,
        undefined
      ];
    }
  });
  let setDateRange = match$2[1];
  let dateRange = match$2[0];
  let match$3 = React.useState(() => DayPickerRange.defaultFocusedInput);
  let setFocusedInput = match$3[1];
  React.useEffect(() => {
    let match = dateRange[0];
    let match$1 = dateRange[1];
    let exit = 0;
    if (value !== undefined) {
      if (match === undefined || match$1 === undefined || value[0].getTime() === match.getTime() && value[1].getTime() !== match$1.getTime()) {
        exit = 1;
      }
    } else if (match !== undefined || match$1 !== undefined) {
      exit = 1;
    }
    if (exit === 1) {
      setDateRange(param => {
        if (value !== undefined) {
          return [
            value[0],
            value[1]
          ];
        } else {
          return [
            undefined,
            undefined
          ];
        }
      });
    }
  }, [value]);
  let onFocusChange = React.useCallback(focusedInput => setFocusedInput(param => {
    if (focusedInput == null) {
      return DayPickerRange.defaultFocusedInput;
    } else {
      return focusedInput;
    }
  }), []);
  React.useEffect(() => {
    let startDate = dateRange[0];
    if (startDate !== undefined) {
      let endDate = dateRange[1];
      if (endDate !== undefined) {
        onChange([
          startDate,
          endDate
        ]);
      }
    } else if (mounted.current) {
      onChange(undefined);
    }
  }, dateRange);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  let onChange$1 = param => {
    let endDate = param[1];
    let startDate = param[0];
    setDateRange(param => [
      startDate !== undefined ? startOfDay(startDate) : undefined,
      endDate !== undefined ? endOfDay(endDate) : undefined
    ]);
    if (Stdlib_Option.isSome(startDate) && Stdlib_Option.isSome(endDate)) {
      return popover.close();
    }
  };
  let handleResetDate = React.useCallback(() => {
    setDateRange(param => [
      undefined,
      undefined
    ]);
    popover.close();
  }, []);
  let startDate = dateRange[0];
  let formattedValue;
  if (startDate !== undefined) {
    let endDate = dateRange[1];
    formattedValue = endDate !== undefined ? I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, startDate) + ` → ` + I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, endDate) : "";
  } else {
    formattedValue = "";
  }
  let endDate$1 = dateRange[1];
  let tmp;
  let exit = 0;
  if (placeholder !== undefined && value === undefined) {
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: placeholder,
      variation: "normal"
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: formattedValue
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(OverlayTriggerView.make, {
          children: tmp,
          preset: {
            NAME: "inputField",
            VAL: {
              required: required,
              tooltip: props.tooltip,
              errorMessage: props.errorMessage
            }
          },
          label: props.label,
          icon: "calendar",
          hovered: match$1[1],
          active: popover.isOpen
        }),
        onPress: param => popover.toggle(),
        ref: popoverTriggerRef
      }),
      popover.isOpen ? JsxRuntime.jsx(Popover.make, {
          children: JsxRuntime.jsxs(Popover.Dialog.make, {
            children: [
              JsxRuntime.jsx(DayPickerRange.make, {
                startDate: dateRange[0],
                endDate: endDate$1,
                focusedInput: match$3[0],
                onChange: onChange$1,
                onFocusChange: onFocusChange
              }),
              JsxRuntime.jsx(Box.make, {
                children: JsxRuntime.jsx(Inline.make, {
                  children: JsxRuntime.jsx(Button.make, {
                    label: I18n.t("Reset period"),
                    variant: "subtle",
                    size: "small",
                    disabled: Stdlib_Option.isNone(endDate$1),
                    icon: "delete",
                    onPress: handleResetDate
                  }),
                  align: "end"
                }),
                spaceX: "large",
                spaceBottom: "medium"
              })
            ],
            ariaProps: match.ariaProps.overlayProps,
            style: {
              minHeight: "300px"
            }
          }),
          triggerRef: popoverTriggerRef,
          state: {
            isOpen: popover.isOpen,
            close: popover.close,
            toggle: popover.toggle
          },
          placement: "bottom start",
          modal: false
        }) : null
    ]
  });
}

let make = React.memo(InputDateRangeField, (oldProps, newProps) => {
  if (oldProps.label === newProps.label && oldProps.value === newProps.value) {
    return oldProps.errorMessage === newProps.errorMessage;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
